<script lang="ts">
  import CloseIcon from '../icons/Close.svelte';

  import Analytics from '../../services/analytics';
  import { AppState } from '../../etc/stores';
  import ThemedIcon from './ThemedIcon.svelte';

  export let headerInternal = false;
  export let hideCloseButton = false;
  export let padding: string = '32px 24px';
  export let closeIcon: any = undefined;
  export let closeStyle: string = '';
  export let className: string = '';
  export let enableScroll: boolean = false;
  export let eventCategoryInCloseGA: string = Analytics.getIsGuest()
    ? 'guest-state'
    : 'join-state';

  const onGAEventClose = () => {
    Analytics.logEvent('click-close', eventCategoryInCloseGA);
  };

  const closePopover = () => {
    onGAEventClose();
    AppState.update(state => ({
      ...state,
      website: {
        ...state.website,
        popoverOpen: false
      }
    }));
  };
</script>

<div
  class={`twism-page ${className} ${enableScroll ? '--scroll' : ''}`}
  class:header-internal={headerInternal}
  style="padding: {padding}"
>
  {#if !hideCloseButton}
    <div class="popover_close" on:click={closePopover} style={closeStyle}>
      {#if closeIcon}
        <svelte:component this={closeIcon} />
      {:else}
        <ThemedIcon>
          <CloseIcon />
        </ThemedIcon>
      {/if}
    </div>
  {/if}
  <slot />
</div>

<style lang="scss">
  .twism-page {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    margin: 0;

    &.--scroll {
      overflow-y: auto;
      overflow-x: hidden;
      overscroll-behavior: contain;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  .twism-page.header-internal {
    height: calc(100% - 62px);
  }

  .popover_close {
    position: absolute;
    right: 24px;
    top: 24px;
    cursor: pointer;
    z-index: 9;
  }
</style>
